/**
 * Per-connector setup guidance (P383.1).
 *
 * `confidence` is load-bearing -- "unverified" means the field list is
 * exact but the vendor-side steps come from documentation rather than
 * from a run we made ourselves. The UI says so rather than hiding it.
 */
import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { api } from "shared/api/client";
import type { SetupGuide } from "shared/api/types";

const KEY = ["admin-setup-guides"] as const;

export function useSetupGuides(): UseQueryResult<SetupGuide[]> {
  return useQuery<SetupGuide[]>({
    queryKey: KEY,
    queryFn: () => api.get<SetupGuide[]>("/v1/admin/connections/setup-guides"),
    staleTime: 5 * 60 * 1000, // static content; no need to refetch often
  });
}
